
document.addEventListener('DOMContentLoaded', function () {
  const firstStep  = document.getElementById('first_step_div');
  const secondStep = document.getElementById('second_step_div');
  const thirdStep  = document.getElementById('third_step_div');

  const CATEGORIES = ['men', 'women', 'boys', 'girls', 'unisex'];

  /** ------------------------
   *  STEP 1 → STEP 2
   *  ------------------------ */

  function activateCategoryInStep2(category) {
    // Highlight category in Step 2 menu
    const menuItems = secondStep.querySelectorAll('.menu_item');
    menuItems.forEach(function (mi) {
      mi.classList.toggle('menu_item_active', mi.dataset.id === category + '_menu');
    });

    // Show correct subcategory block
    CATEGORIES.forEach(function (cat) {
      const block = document.getElementById(cat + '_subcategories');
      if (block) {
        block.style.display = (cat === category) ? 'flex' : 'none';
      }
    });
  }

  // Click on big category buttons in Step 1
  document.querySelectorAll('#first_step_div .category_item').forEach(function (item) {
    item.addEventListener('click', function () {
      // "men_category" → "men"
      var raw = this.dataset.id || '';
      var category = raw.split('_')[0]; 

      if (!category) return;

      firstStep.style.display  = 'none';
      thirdStep.style.display  = 'none';
      secondStep.style.display = 'block';

      activateCategoryInStep2(category);
    });
  });

  // Category menu inside Step 2
  secondStep.querySelectorAll('.menu_item').forEach(function (mi) {
    mi.addEventListener('click', function () {
      var category = (this.dataset.id || '').replace('_menu', '');
      if (!category) return;
      activateCategoryInStep2(category);
    });
  });

  /** ------------------------
   *  STEP 2 → STEP 3
   *  ------------------------ */

  // All the step-2 subcategory tiles (Tops, Bottoms, etc.)
  secondStep.querySelectorAll('.flex_subcategory').forEach(function (subcat) {
    subcat.addEventListener('click', function () {
      var category = this.dataset.category;                 // "men"
      var rawId    = this.dataset.id || '';                 // "men_tops_btn"
      var parts    = rawId.split('_');                      // ["men","tops","btn"]
      var sub      = parts[1];                              // "tops"

      if (!category || !sub) return;

      goToThirdStep(category, sub);
    });
  });

  /** ------------------------
   *  STEP 3 CATEGORY / SUBCATEGORY
   *  ------------------------ */

  function activateCategoryInStep3(category) {
    // Highlight category tab in Step 3
    const menuItems = thirdStep.querySelectorAll('.category_menus .menu_item');
    menuItems.forEach(function (mi) {
      mi.classList.toggle('menu_item_active', mi.dataset.id === category + '_menu');
    });

    // Show correct strip of subcategory icons (tops/bottoms/…)
    CATEGORIES.forEach(function (cat) {
      const catMenu = document.getElementById(cat + '_categories');
      if (catMenu) {
        catMenu.style.display = (cat === category) ? 'flex' : 'none';
      }
    });
  }

  // Collect content sections inside Step 3 (men-tops, women-bottoms, etc.)
  const contentSections = [];
  Array.prototype.forEach.call(thirdStep.children, function (child) {
    if (
      child.id &&
      !child.classList.contains('category_menus') &&
      !child.classList.contains('subcategory_menus')
    ) {
      contentSections.push(child);
      // Hide all by default; we'll show as needed
      child.style.display = 'none';
    }
  });

  function showContentSection(id) {
    contentSections.forEach(function (section) {
      section.style.display = (section.id === id) ? 'block' : 'none';
    });
  }

  function setActiveSubcategoryItem(category, sub) {
    var catMenu = document.getElementById(category + '_categories');
    if (!catMenu) return;

    var targetId = category + '-' + sub + '-btn';   // e.g. "men-tops-btn"

    catMenu.querySelectorAll('.subcategory_item').forEach(function (item) {
      var active = (item.dataset.id === targetId);

      // Text colour
      item.style.color = active ? '#000000' : '#8c8c8c';

      // Icon colour
      var svg = item.querySelector('svg');
      if (svg) {
        svg.style.fill = active ? '#000000' : '#8c8c8c';
      }
    });
  }

  function goToThirdStep(category, sub) {
    firstStep.style.display  = 'none';
    secondStep.style.display = 'none';
    thirdStep.style.display  = 'block';

    activateCategoryInStep3(category);
    setActiveSubcategoryItem(category, sub);
    showContentSection(category + '-' + sub);
  }

  // Category tabs at the top of Step 3
  thirdStep.querySelectorAll('.category_menus .menu_item').forEach(function (mi) {
    mi.addEventListener('click', function () {
      var category = (this.dataset.id || '').replace('_menu', '');
      if (!category) return;

      activateCategoryInStep3(category);

      // Default subcategory within this category = first icon
      var catMenu = document.getElementById(category + '_categories');
      if (catMenu) {
        var firstItem = catMenu.querySelector('.subcategory_item');
        if (firstItem && firstItem.dataset.id) {
          var parts = firstItem.dataset.id.split('-'); // "men-tops-btn"
          var sub   = parts[1];
          setActiveSubcategoryItem(category, sub);
          showContentSection(category + '-' + sub);
        }
      }
    });
  });

  // Sub-category icons in Step 3 (Tops / Bottoms / Footwear / etc.)
  thirdStep.querySelectorAll('.subcategory_menus .subcategory_item').forEach(function (item) {
    item.addEventListener('click', function () {
      var raw  = this.dataset.id || '';       // "men-tops-btn"
      var parts = raw.split('-');             // ["men","tops","btn"]
      var category = parts[0];
      var sub      = parts[1];

      if (!category || !sub) return;

      activateCategoryInStep3(category);
      setActiveSubcategoryItem(category, sub);
      showContentSection(category + '-' + sub);
    });
  });

  /** ------------------------
   *  INCHES / CM TOGGLE
   *  ------------------------ */

  document.querySelectorAll('.size_buttons .switch_btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var isInch = (this.dataset.id === 'inch-btn');
      var buttonsContainer = this.parentElement;

      // Button states
      buttonsContainer.querySelectorAll('.switch_btn').forEach(function (b) {
        b.classList.toggle('switch_active', b === btn);
      });

      // Find the nearest top-level size section that this toggle belongs to
      var section = buttonsContainer.closest('#third_step_div > div[id]');
      if (!section) {
        // fallback: walk up until we find a parent with an id
        var parent = buttonsContainer.parentElement;
        while (parent && !parent.id) {
          parent = parent.parentElement;
        }
        section = parent;
      }
      if (!section) return;

      var inchesTables = section.querySelectorAll('.inches_table');
      var cmTables     = section.querySelectorAll('.centimeters_table');

      inchesTables.forEach(function (tbl) {
        tbl.style.display = isInch ? '' : 'none';
      });
      cmTables.forEach(function (tbl) {
        tbl.style.display = isInch ? 'none' : '';
      });
    });
  });

  /** ------------------------
   *  OPTIONAL: start directly on a given guide
   *  (uncomment if you ever want to skip Step 1 & 2)
   *  ------------------------ */
  // goToThirdStep('men', 'tops');
});

